(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[202],{

/***/ 66489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1048);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32793);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90512);
/* harmony import */ var _mui_base_composeClasses__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94780);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98216);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71657);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90948);
/* harmony import */ var _circularProgressClasses__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22346);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;











const SIZE = 44;
const circularRotateKeyframe = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_t || (_t = _`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const circularDashKeyframe = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_t2 || (_t2 = _`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    color,
    disableShrink
  } = ownerState;
  const slots = {
    root: ['root', variant, `color${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(color)}`],
    svg: ['svg'],
    circle: ['circle', `circle${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(variant)}`, disableShrink && 'circleDisableShrink']
  };
  return (0,_mui_base_composeClasses__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(slots, _circularProgressClasses__WEBPACK_IMPORTED_MODULE_5__/* .getCircularProgressUtilityClass */ .C, classes);
};
const CircularProgressRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`color${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
  display: 'inline-block'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('transform')
}, ownerState.color !== 'inherit' && {
  color: (theme.vars || theme).palette[ownerState.color].main
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_t3 || (_t3 = _`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe));
const CircularProgressSVG = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: (props, styles) => styles.svg
})({
  display: 'block' // Keeps the progress centered
});

const CircularProgressCircle = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.circle, styles[`circle${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ownerState.variant)}`], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(({
  ownerState,
  theme
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
  stroke: 'currentColor'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('stroke-dashoffset')
}, ownerState.variant === 'indeterminate' && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_t4 || (_t4 = _`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const CircularProgress = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CircularProgress(inProps, ref) {
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiCircularProgress'
  });
  const {
      className,
      color = 'primary',
      disableShrink = false,
      size = 40,
      style,
      thickness = 3.6,
      value = 0,
      variant = 'indeterminate'
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props, {
    color,
    disableShrink,
    size,
    thickness,
    value,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};
  if (variant === 'determinate') {
    const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = 'rotate(-90deg)';
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CircularProgressRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.root, className),
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
      width: size,
      height: size
    }, rootStyle, style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps, other, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (CircularProgress);

/***/ }),

/***/ 22346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getCircularProgressUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);


function getCircularProgressUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiCircularProgress', slot);
}
const circularProgressClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);
/* harmony default export */ __webpack_exports__["Z"] = (circularProgressClasses);

/***/ }),

/***/ 36016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M29.909 3c.843 0 1.599.094 2.269.28.669.188 1.218.42 1.65.695.43.277.797.637 1.1 1.083.301.445.521.847.66 1.203.136.356.246.802.33 1.336.081.535.128.936.137 1.203.008.268.013.615.013 1.043 0 .677-.086 1.354-.26 2.031-.175.678-.349 1.212-.523 1.604a21.86 21.86 0 0 1-1.03 1.978c-.129.214-.23.41-.303.588a6.603 6.603 0 0 0-.22.642h7.616c1.43 0 2.667.508 3.711 1.524 1.043 1.016 1.566 2.219 1.566 3.609 0 1.533-.504 2.86-1.512 3.983.275.784.412 1.461.41 2.032.055 1.354-.339 2.575-1.182 3.662.311.998.311 2.04 0 3.127-.274 1.016-.77 1.853-1.484 2.512.164 1.996-.285 3.61-1.348 4.839-1.173 1.354-2.978 2.05-5.416 2.085h-3.547c-1.21 0-2.529-.139-3.959-.415-1.428-.276-2.543-.535-3.34-.775-.797-.24-1.901-.593-3.312-1.056-2.255-.766-3.703-1.158-4.345-1.176a1.843 1.843 0 0 1-1.237-.522 1.579 1.579 0 0 1-.522-1.189V21.792c0-.446.165-.833.495-1.163.33-.33.724-.513 1.182-.548.44-.036 1.136-.561 2.09-1.578a49.419 49.419 0 0 0 2.776-3.234c1.247-1.55 2.173-2.62 2.777-3.207.33-.321.614-.749.853-1.284.238-.534.399-.966.481-1.296.083-.33.206-.868.372-1.617a25.24 25.24 0 0 1 .343-1.63c.1-.393.28-.856.536-1.39.257-.535.569-.98.935-1.337.349-.339.761-.508 1.238-.508ZM11.686 20.963c.427 0 .797.17 1.11.508.312.339.469.74.469 1.203v17.108c0 .463-.157.864-.47 1.203-.312.338-.682.508-1.11.508H4.58c-.428 0-.798-.17-1.111-.508A1.715 1.715 0 0 1 3 39.782V22.674c0-.463.156-.864.469-1.203.312-.338.683-.508 1.11-.508ZM7.738 34.65c-.445 0-.819.17-1.123.508a1.74 1.74 0 0 0-.456 1.203c0 .481.152.887.456 1.216.304.33.678.495 1.123.495.427 0 .797-.165 1.11-.495.313-.33.469-.735.469-1.216 0-.463-.156-.864-.47-1.203-.312-.338-.682-.508-1.11-.508Z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgThumbsUp);

/***/ }),

/***/ 78408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_useHandleSearchSubmit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3354);
/* harmony import */ var _src_components_atoms_breadcrumbs_breadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86724);
/* harmony import */ var _src_components_atoms_breadcrumbs_breadcrumbs_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64221);
/* harmony import */ var _src_components_molecules_subpage_sticky_bar_subpage_sticky_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62217);
/* harmony import */ var _src_components_sections_head_tags_head_tags__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92848);
/* harmony import */ var _src_components_sections_landing_breadcrumbs_landing_breadcrumbs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92885);
/* harmony import */ var _src_components_sections_ugc_ugc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14320);
/* harmony import */ var _src_components_sections_ugc_ugc_data__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99805);
/* harmony import */ var _src_contexts_locale_config_locale_config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36097);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ReviewsPage = function ReviewsPage(props) {
  var _props$pageProps, _props$pageProps2, _props$pageProps3, _props$pageProps3$get, _props$pageProps4;

  var localeConfig = react__WEBPACK_IMPORTED_MODULE_1__.useContext(_src_contexts_locale_config_locale_config__WEBPACK_IMPORTED_MODULE_10__/* .LocaleConfigContext */ .nO);
  var modulesData = props === null || props === void 0 ? void 0 : (_props$pageProps = props.pageProps) === null || _props$pageProps === void 0 ? void 0 : _props$pageProps.modulesData;
  var landingPage = props === null || props === void 0 ? void 0 : (_props$pageProps2 = props.pageProps) === null || _props$pageProps2 === void 0 ? void 0 : _props$pageProps2.getLandingPage;
  var meta = props === null || props === void 0 ? void 0 : (_props$pageProps3 = props.pageProps) === null || _props$pageProps3 === void 0 ? void 0 : (_props$pageProps3$get = _props$pageProps3.getLandingPage) === null || _props$pageProps3$get === void 0 ? void 0 : _props$pageProps3$get.meta;
  var slug = props === null || props === void 0 ? void 0 : (_props$pageProps4 = props.pageProps) === null || _props$pageProps4 === void 0 ? void 0 : _props$pageProps4.slug;
  var breadcrumbsPath = (0,_src_components_sections_landing_breadcrumbs_landing_breadcrumbs__WEBPACK_IMPORTED_MODULE_7__/* .getBreadcrumbsPath */ .bp)(landingPage, modulesData, localeConfig);
  var hostUrl = props === null || props === void 0 ? void 0 : props.hostUrl;
  var shipPageUrl = "/".concat(localeConfig.slugs.ship.prefix, "/").concat(landingPage.slug);

  var headTagsData = _objectSpread(_objectSpread({}, meta), {}, {
    hostUrl: hostUrl,
    landingPage: landingPage,
    modulesData: modulesData,
    pageType: 'landingPage'
  });

  var subPageObserverRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
  var handleSubmit = (0,src_hooks_useHandleSearchSubmit__WEBPACK_IMPORTED_MODULE_2__/* .useHandleSearchSubmit */ .r)({
    id: landingPage.id,
    type: landingPage.type,
    title: landingPage.title
  });
  var ugcProps = (0,_src_components_sections_ugc_ugc_data__WEBPACK_IMPORTED_MODULE_9__/* .getUGCPropsFromData */ .Hz)({
    modulesData: modulesData,
    getLandingPage: landingPage,
    slug: slug,
    ugcSlug: localeConfig.slugs.ugc,
    subpage: landingPage.subpage
  });

  if (!ugcProps) {
    return null;
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_src_components_sections_head_tags_head_tags__WEBPACK_IMPORTED_MODULE_6__/* .HeadTags */ .c, _objectSpread({}, headTagsData)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("div", {
      ref: subPageObserverRef,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_src_components_molecules_subpage_sticky_bar_subpage_sticky_bar__WEBPACK_IMPORTED_MODULE_5__/* .SubpageStickyBar */ .j, {
        observerRef: subPageObserverRef,
        shipUrl: shipPageUrl,
        onSearchSubmit: handleSubmit
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_src_components_sections_ugc_ugc__WEBPACK_IMPORTED_MODULE_8__/* .UGC */ .s, _objectSpread({}, ugcProps)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_src_components_atoms_breadcrumbs_breadcrumbs_style__WEBPACK_IMPORTED_MODULE_4__/* .StyledBreadcrumbsContainer */ .x, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_src_components_atoms_breadcrumbs_breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* .Breadcrumbs */ .O, {
        paths: breadcrumbsPath
      })
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ReviewsPage);

/***/ }),

/***/ 62217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ SubpageStickyBar; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/hoc/sticky/sticky.tsx + 2 modules
var sticky = __webpack_require__(18210);
// EXTERNAL MODULE: ./src/contexts/device/device.tsx
var device_device = __webpack_require__(90780);
// EXTERNAL MODULE: ./src/utils/formatting.ts
var formatting = __webpack_require__(62556);
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.style.tsx
var dreamlines_button_style = __webpack_require__(35246);
;// CONCATENATED MODULE: ./src/components/molecules/subpage-sticky-bar/subpage-sticky-bar.style.tsx



var StyledSubpageSticky = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2mde040"
} : 0)("background-color:#ffffff;padding:10px 6px;border-bottom:2px solid ", function (props) {
  return props.theme.colorsUnifications.whiteSmoke[100];
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding:16px 0;}.container{display:flex;align-items:center;}", dreamlines_button_style/* StyledButton */.Sn, "{@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding-top:20px;padding-bottom:20px;padding-left:20px;}}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.tsx
var dreamlines_button = __webpack_require__(2730);
// EXTERNAL MODULE: ./src/components/atoms/back-button/back-button.tsx + 1 modules
var back_button = __webpack_require__(55029);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/molecules/subpage-sticky-bar/subpage-sticky-bar.tsx










var SubpageStickyBar = function SubpageStickyBar(props) {
  var device = react.useContext(device_device/* DeviceContext */.Tp);
  var formattedOfferCount = (0,formatting/* replaceVal */.yy)((0,translation_service.__)('seeAllOffers'), '');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sticky/* Sticky */.L, {
    observerRef: props.observerRef,
    children: function children(sticky) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubpageSticky, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: "container",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(back_button/* BackButton */.x, {
            href: props.shipUrl,
            children: (0,translation_service.__)('backToShipOverview')
          }), device !== 'mobile' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
            wrapperStyle: {
              marginLeft: 'auto'
            },
            style: {
              borderRadius: '6px',
              fontWeight: '600'
            },
            onClick: props.onSearchSubmit,
            children: formattedOfferCount
          })]
        })
      });
    }
  });
};

/***/ }),

/***/ 37272:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship/[slug]/reviews",
      function () {
        return __webpack_require__(78408);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4929,8371,7314,9543,2848,7486,6154,8090,9774,2888,179], function() { return __webpack_exec__(37272); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);